<template>
    <div>
        <p>Spiel-/Programmziele</p>
        <div v-for="(category, index) in categories" class="filter-box">
            <v-expansion-panels multiple v-model="panel[index]">
                <v-expansion-panel>
                    <v-expansion-panel-header>
                        <div class="collapsable-header">
                            <div class="bold">{{ category.title }}</div>
                        </div>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                        <div class="collapsable-inner">
                            <div class="filter-content">
                                <v-checkbox
                                    v-for="objective in category.objectives"
                                    v-model="objectives"
                                    :value="objective.id"
                                    :label="objective.name"
                                    color="#33bbff"
                                    hide-details
                                ></v-checkbox>
                            </div>
                        </div>
                    </v-expansion-panel-content>
                </v-expansion-panel>
            </v-expansion-panels>
        </div>
    </div>

</template>

<script>
export default {
    props: ["categories", 'open', 'resetObjective'],
    data() {
        return {
            objectives: [],
            panel: []
        };
    },
    watch: {
        objectives() {
            //console.log(this.infra);
            this.$emit("input", this.objectives);
        },
        resetObjective(newVal, oldVal) {
            if (newVal !== oldVal && newVal === true) {
                this.objectives = [];
                this.panel = new Array(this.categories.length).fill(false);
                this.$emit("resetSignal", false);  // Notify parent that reset is done
            }
        },
    },
    methods: {
        changeOpen(val) {
            this.$emit('open', val);
        },
    },
    mounted() {
        console.log("mounted filters");
        this.panel = new Array(this.categories.length).fill(false);
    },
    created() {
    },
    computed: {},
};
</script>

<style>
</style>
